import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { DatabaseOperationService } from '../../../api/database/database-operation.service';
import { DatalistService } from '../../../api/services/datalist.service';
import { FunctionService } from '../../../api/services/function.service';

@Component({
  selector: 'app-event-register-form-popup',
  templateUrl: './event-register-form-popup.component.html',
  styleUrls: ['./event-register-form-popup.component.css']
})
export class EventRegisterFormPopupComponent implements OnInit {
  EventId;
  EventDetails: any;
  RegistrationForm: any;
  formInvalid: boolean;
  submitted: boolean;
  constructor(
    public datalistService: DatalistService,
    private databaseOperationService: DatabaseOperationService,
    private matDialog: MatDialog,
    public functionService: FunctionService,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialogRef<EventRegisterFormPopupComponent>,
    private formBuilder: FormBuilder,) {
    this.datalistService.loaderActive = true;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      // this.EventId = params['EventId'];
      this.databaseOperationService.getBlogById(this.EventId).subscribe((data: any) => {
        this.EventDetails = data;
        this.datalistService.loaderActive = false;
        console.log(this.EventDetails);
      });
    })
    this.RegistrationForm = this.formBuilder.group({
      EventId:this.EventId,
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      Email: ['', [Validators.required, Validators.email]],
      Phone: ['', Validators.required],
      IsStudent: ['', Validators.required],
      StudentCourse: [''],
      HearAboutEvent: ['', Validators.required],
      HearAboutEventOther: [''],
      Questions: [''],
    });
  }
  get formControl() { return this.RegistrationForm.controls; }
  onSubmit() {
    this.datalistService.loaderActive = true;
    this.formInvalid = false;
    this.submitted = false;
    if (this.RegistrationForm.valid) {
      this.databaseOperationService.sendEventConfirmationMail(this.RegistrationForm.value).subscribe((data: any) => {
      });
      this.databaseOperationService.saveEventRegister(this.RegistrationForm.value).subscribe((data: any) => {
        this.datalistService.loaderActive = false;
        // this.functionService.showProcessMessage("Registered successfully ", true);
        // this.datalistService.loaderActive = false;
        this.dialog.close(false);
        if(data.EventRegisterId){
          Swal.fire({
            title: 'Saved Successfully',
            icon: 'success',
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
          })
        }
        else{
          Swal.fire("Please provide valid information")
        }
      })
    } else {
      this.submitted = true;
      this.functionService.showProcessMessage("Please provide valid information", false);
      this.datalistService.loaderActive = false;
     }
  }

  dateTime = new Date();
  isActive(Date) {
    let date1 = formatDate(this.dateTime, 'yyyy-MM-dd', 'en_US');
    let date2 = formatDate(Date, 'yyyy-MM-dd', 'en_US');
    // this.dateTime
    // let EventDate=Date.getTime();
    return (date2 >= date1)
  }
}
